import type { ReactNode } from 'react'

import { PageHeaderStack } from '@/components/navigation/page-header-stack'
import { cn } from '@/lib/utils'

export type AuthoringCaseFileProps = {
  /** Page header / toolbar stack. */
  header: ReactNode
  /** Left block palette rail. */
  palette?: ReactNode
  /** Main authoring document. */
  document: ReactNode
  /** Sections below the document (preview, history, etc.). */
  below?: ReactNode
  className?: string
}

/**
 * Case-file layout for platform authoring: header stack, optional palette + document row,
 * then stacked meta sections.
 */
export function AuthoringCaseFile({
  header,
  palette,
  document,
  below,
  className,
}: AuthoringCaseFileProps) {
  return (
    <div className={cn('space-y-6', className)}>
      <PageHeaderStack compact>{header}</PageHeaderStack>
      <div
        className={cn(
          'flex flex-col gap-4',
          palette ? '@md:flex-row @md:items-start' : undefined,
        )}
      >
        {palette}
        <div className="min-w-0 flex-1 space-y-4">{document}</div>
      </div>
      {below ? <div className="space-y-4">{below}</div> : null}
    </div>
  )
}
